import { useParams } from "react-router-dom";

export default function GroupPhotoSeries() {
  const { slug, seriesType } = useParams();

  if (!slug || !seriesType) {
    return <></>;
  }

  return (
    <>
      photo series:&nbsp;
      {slug} - {seriesType}
    </>
  );
}
